import http from '@/libs/AxiosPlugin'

const workTime = {
  list () {
    return http.get('/workTime/list')
    // return new Promise((resolve, reject) => {
    //   let data = [
    //     {id: 1, name: '早班', startTime: '8:00', endTime: '16:00'},
    //     {id: 2, name: '中班', startTime: '16:00', endTime: '24:00'},
    //     {id: 3, name: '晚班', startTime: '00:00', endTime: '8:00'}
    //   ]
    //   resolve(data)
    // })
  },

  delete (id) {
    return http.post('/workTime/delete', {id})
  },

  get (id) {
    return http.post('/workTime/get', {id})
  },

  save (wt) {
    return http.post('/workTime/save', wt)
  }
}

export default workTime



// WEBPACK FOOTER //
// ./src/api/workTime.js